import { ObjectKey, QueryColumn, QueryParameter } from '@barthauer/abc/core/data';
import { IStorage } from '@barthauer/abc/ui-components';
import { dxDataGridColumn } from 'devextreme/ui/data_grid';

export class ObjectSelectionGroup {
  name!: string;
  designation?: string;
  objectTypeNameOrQueryInfo?: string | SimpleObjectQueryInfo | ReadListDataSourceInfo;
  preselectionKeyExpr?: string;
  preselectedKeys?: any[];
  layoutStorage?: IStorage;
  layoutStorageKey?: string;

  /** See {@link https://js.devexpress.com/Documentation/ApiReference/UI_Components/dxDataGrid/Configuration/#onCellPrepared} */
  filterForDisabledRows?: (onCellPreparedEventArgs: any) => boolean;

  constructor(obj?: any) {
    if (obj) {
      Object.assign(this, obj);

    }
  }
}

export class SimpleObjectQueryInfo {
  objectSpace!: string;
  objectType!: string;
  oPathFilter?: string;
  limitCount?: number;
  limitOffset?: number;
  isDistinct?: boolean;
  defaultIfEmpty?: boolean;
  columns?: QueryColumn[];
  parameters?: QueryParameter[];
  /**
   * DevExpress grid columns options. <br/>
   * See {@link https://js.devexpress.com/Documentation/ApiReference/UI_Components/dxDataGrid/Configuration/columns/}
   */
  columnHeaders?: dxDataGridColumn[];

  constructor(obj?: any) {
    if (obj) {
      Object.assign(this, obj);
    }
  }

  public static isSimpleObjectQueryInfo(obj: any): obj is SimpleObjectQueryInfo {
    return typeof obj.objectSpace === 'string' && typeof obj.objectType === 'string';
  }
}

export class ReadListDataSourceInfo {
  objectKey!: ObjectKey;
  columnName!: string;
  parameters?: QueryParameter[];

  constructor(obj?: any) {
    if (obj) {
      Object.assign(this, obj);
    }
  }

  public static isReadListDataSourceInfo(obj: any): obj is ReadListDataSourceInfo {
    return obj.objectKey instanceof ObjectKey && typeof obj.columnName === 'string';
  }
}
